/* eslint-disable import/named */
import { useMemo } from 'react';
import useSWR, { KeyedMutator } from 'swr';
import { fetcher } from '@/plugins/graphql';
import { Level } from '@/types/Level';
export const PER_PAGE = 50;

type useGetAllLevel = [
  {
    data: Level[] | undefined;
    error: any;
    mutate: KeyedMutator<any>;
  },
];

const useGetAllLevel = (schema?: string): useGetAllLevel => {
  // 一覧と総件数を取得
  const query = useMemo(() => {
    return `
      query Levels {
        ${schema}_level {
          level_name
          id
        }
      }
    `;
  }, [schema]);

  const { data, error, mutate } = useSWR(query, fetcher, {
    revalidateOnFocus: false,
  });

  const levels = useMemo(() => {
    return data?.[`${schema}_level`] || [];
  }, [data, schema]);

  return [
    {
      data: levels,
      error,
      mutate,
    },
  ];
};

export default useGetAllLevel;
